<template>
  <div id="myNav" class="overlay"
    @keydown="keydownOverlay"
    v-if="this.isVisible">

    <div class="slideshow-container">
      <div>
        <img id="imgPictureView" :src="this.image" class="imgSlideShow">

        <a class="prev" @click="onclickplus(-1)">&#10094;</a>
        <a class="next" @click="onclickplus(1)">&#10095;</a>
      </div>
    </div>
    <div style="text-align:center" class="divDot"
      v-for="index in this.imagesTotal"
      :key="index"
    >
      <span
        class="dot"
        v-bind:class="classDot[index - 1]"
        @click="onclickdotChild(index - 1)"
      ></span>
    </div>

    <a href="javascript:void(0)" class="closebtn" @click="onClickClose">&times;</a>
  </div>
</template>

<script>
export default {
  props: [
    'isVisible',
    'imagesTotal',
    'image',
    'imageSelected',
  ],
  watch: {
    imageSelected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.classDot = [];
        for (let index = 0; index < this.imagesTotal; index += 1) {
          if (index === newValue) {
            this.classDot.push('active');
          } else {
            this.classDot.push('');
          }
        }
      },
    },
    isVisible: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          window.addEventListener('keydown', this.keydownOverlay);
        }
      },
    },
  },
  data() {
    return {
      classDot: [],
    };
  },
  methods: {
    onclickdotChild(value) {
      this.$emit('onclickdot', value);
    },
    onclickplus(value) {
      this.$emit('onclickplusslides', value);
    },
    onClickClose() {
      window.removeEventListener('keydown', this.keydownOverlay);
      this.$emit('onclickclose');
    },
    keydownOverlay(event) {
      switch (event.keyCode) {
        case 37:
          this.$emit('onclickplusslides', -1);
          break;
        case 39:
          this.$emit('onclickplusslides', 1);
          break;
        case 27:
          this.onClickClose();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style>
/* The Overlay (background) */
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  background-color: rgb(0,0,0); /* Black fallback color */
  background-color: rgba(0,0,0, 0.9); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay
  (height or width, depending on reveal) */
}

/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover, .overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}

/* When the height of the screen is less than 450 pixels, change the
font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {font-size: 20px}
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}

* {box-sizing:border-box}

/* Slideshow container */
.slideshow-container {
  max-width: 1280px;
  width: 80%;
  height: calc(92%);
  position: relative;
  margin: auto;
  padding-top: 50px;
}
.imgSlideShow {
  position: absolute;
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(90%);
  max-width: calc(90%);
}

/* Next & previous buttons */
.prev, .next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  margin-top: -22px;
  padding: 16px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}

/* Position the "next button" to the right */
.next {
  right: 0;
  border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev:hover, .next:hover {
  background-color: rgba(0,0,0,0.8);
}

/* The dots/bullets/indicators */
.dot {
  cursor: pointer;
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
}
.divDot {
  display: inline-block;
}

.active, .dot:hover {
  background-color: #717171;
}

@-webkit-keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4}
  to {opacity: 1}
}
</style>
